
//REQUIRED for global variable: useContext, AppContext, refer to default.js

import {
    Result
} from 'antd';

export default function T_Error() {
    return (
        <>
            <Result
                status="404"
                title={<span>Page Not Found
                </span>
                }
                subTitle={<span>
                    Could not find the page you're defining <b>{window.location.pathname}</b>
                    <br />If you believe this was caused by mistake, please consult system administrator for further investigation.
                </span>
                }
                extra={
                    <span>Wish to be redirected to <a href="/">Main Page</a>?</span>}
            />

        </>)






}